import React, { useContext, useEffect, useState } from "react";
import Swal from "sweetalert2";
import {
  Button,
  Modal,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  ListGroup,
  ListGroupItem,
  Spinner,
} from "reactstrap";
import Select from "react-select";
import classnames from "classnames";

import AuthService from "../../../../services/User/AuthService";
import RechargeService from "../../../../services/User/RechargeService";
import HttpError from "../../../../utill/HttpError";
import LoadingContext from "../../../../store/loading-context";

const ViewPlansDialog = (props) => {
  const {
    open,
    handleClose,
    operator,
    circle,
    setCircle,
    plansData,
    handleSetPlansData,
    handleSetAmount,
  } = props;

  const loadingCtx = useContext(LoadingContext);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("0");

  const circles = [
    { value: "Andhra Pradesh", label: "Andhra Pradesh" },
    { value: "Assam", label: "Assam" },
    { value: "Bihar / Jharkhand", label: "Bihar / Jharkhand" },
    { value: "Chennai", label: "Chennai" },
    { value: "Delhi NCR", label: "Delhi NCR" },
    { value: "Gujarat", label: "Gujarat" },
    { value: "Haryana", label: "Haryana" },
    { value: "Himachal Pradesh", label: "Himachal Pradesh" },
    { value: "Jammu Kashmir", label: "Jammu Kashmir" },
    { value: "Karnataka", label: "Karnataka" },
    { value: "Kerala", label: "Kerala" },
    { value: "Kolkata", label: "Kolkata" },
    {
      value: "Madhya Pradesh / Chhattisgarh",
      label: "Madhya Pradesh / Chhattisgarh",
    },
    { value: "Maharashtra", label: "Maharashtra" },
    { value: "Mumbai", label: "Mumbai" },
    { value: "North East", label: "North East" },
    { value: "Orissa", label: "Orissa" },
    { value: "Punjab", label: "Punjab" },
    { value: "Rajasthan", label: "Rajasthan" },
    { value: "Tamil Nadu", label: "Tamil Nadu" },
    { value: "UP East", label: "UP East" },
    { value: "UP West", label: "UP West" },
    { value: "West Bengal", label: "West Bengal" },
  ];

  useEffect(() => {
    if (circle) {
      fetchPlans(circle);
    }
  }, [circle]);

  const fetchPlans = async (selectedCircle) => {
    if (!selectedCircle) return;

    handleSetPlansData();
    setLoading(true);

    try {
      const token = AuthService.getAccessToken();
      const response = await RechargeService.fetchPlans(
        token,
        operator?.label || "",
        selectedCircle
      );

      if (response.status === "SUCCESS") {
        handleSetPlansData(response.data);
        setActiveTab("0"); // Reset tab to first one
      } else {
        Swal.fire("Oops!", response.message, "error");
      }
    } catch (error) {
      const errMsg = HttpError.getError(error);
      handleClose();
      Swal.fire("Oops!", errMsg, "error");
    }

    setLoading(false);
  };

  return (
    <Modal size="lg" isOpen={open} toggle={handleClose}>
      <div className="modal-header">
        <h5 className="modal-title">Browse Plans</h5>
        {operator?.image && (
          <img src={operator.image} alt="operator-logo" height="50px" />
        )}
      </div>
      <ModalBody>
        <div className="mb-3">
          <Select
            defaultValue={{ label: circle, value: circle }}
            onChange={(e) => {
              setCircle(e.value);
              fetchPlans(e.value);
            }}
            options={circles}
          />
        </div>

        {loading ? (
          <div className="text-center">
            <Spinner color="primary" />
          </div>
        ) : (
          <>
            {plansData && plansData.length > 0 ? (
              <>
                <Nav tabs className="nav-tabs nav-justified mb-3">
                  {plansData.map((tab, index) => (
                    <NavItem key={index}>
                      <NavLink
                        className={classnames({
                          active: activeTab === `${index}`,
                        })}
                        onClick={() => setActiveTab(`${index}`)}
                        style={{ cursor: "pointer" }}
                      >
                        {tab.tab_name}
                      </NavLink>
                    </NavItem>
                  ))}
                </Nav>

                <TabContent activeTab={activeTab}>
                  {plansData.map((tab, index) => (
                    <TabPane key={index} tabId={`${index}`}>
                      <ListGroup>
                        {tab.data.map((plan, idx) => (
                          <ListGroupItem
                            key={idx}
                            className="list-group-item-action"
                            onClick={() => {
                              handleSetAmount(plan.amount);
                              handleClose();
                            }}
                          >
                            <Button
                              color="primary"
                              className="float-end ms-3 rounded-pill"
                            >
                              ₹{plan.amount}
                            </Button>
                            <div className="d-flex align-items-center">
                              <div className="flex-grow-1">
                                <h6 className="fs-12 mb-1">
                                  {plan.planDescription}
                                </h6>
                                <p className="mb-0 fs-12">{plan.validity}</p>
                              </div>
                            </div>
                          </ListGroupItem>
                        ))}
                      </ListGroup>
                    </TabPane>
                  ))}
                </TabContent>
              </>
            ) : (
              <p className="text-center">No plans available.</p>
            )}
          </>
        )}
      </ModalBody>
    </Modal>
  );
};

export default ViewPlansDialog;
